<template>
  <v-form class="px-4">
    <h2>
      Terms &amp; Conditions*
    </h2>
    <v-row>
      <v-col>
        <terms-conditions-component
          :tenant="tenant"
          @tcs-clicked="unlock()"
        />
        <signature-component
          ref="sig"
          :loading="loading"
          :disabled="disabled"
          :additional-text="additionalText"
          @signatureSaved="uploadSignature($event)"
        />
      </v-col>
    </v-row>
    <v-btn
      tile
      outlined
      color="agency-color-secondary"
      :disabled="loading"
      :loading="loading"
      @click="goBack()"
    >
      Back
    </v-btn>
    <v-btn
      tile
      dark
      color="agency-color-primary"
      :disabled="!signed"
      :loading="loading"
      @click="submit()"
    >
      Submit
    </v-btn>
  </v-form>
</template>
<script>
export default {
  name: 'TermsConditionsSignatureComponent',
  props: {
    candidate: {
      type: Object,
      default: () => {
        return {
          candidate_details: {},
          candidate_nok: {}
        }
      }
    },
    tenant: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    loading: false,
    disabled: true,
    signed: false,
    newCandidate: {
      signature_url_terms: ''
    }
  }),
  computed: {
    additionalText () {
      return 'Then click SAVE and SUBMIT'
    }
  },
  created () {
    this.signed = this.candidate.signature_url !== undefined
  },
  methods: {
    submit () {
      this.$emit('submit', {
        newCandidate: this.candidate
      })
    },
    goBack () {
      this.$emit('back')
    },
    uploadSignature (image) {
      const self = this
      self.loading = true
      const formData = new FormData()
      formData.append('file', image)
      formData.append('first_name', self.candidate.first_name)
      formData.append('last_name', self.candidate.last_name)
      axios.post(self.URLs.core.candidates.candidateSignature, formData)
        .then(response => {
          self.candidate.signature_url_terms = response.data
          self.loading = false
          self.disabled = true
          self.signed = true
        })
    },
    unlock () {
      this.disabled = false
      this.$refs.sig.redraw()
    }
  }
}
</script>
<style lang='scss'>
    #TermsConditionsSignatureComponent {
        //
    }
</style>
